<!-- <div class="custom-dialog"> -->
	<!-- <h1 mat-dialog-title>Are You Sure?</h1>
	<mat-dialog-content>
			Are you sure you want to continue with this zipcode.
	</mat-dialog-content>
	<mat-dialog-actions align="end">
		<button mat-button mat-raised-button [mat-dialog-close]="false">No</button>
		<button mat-raised-button color="warn" [mat-dialog-close]="true">Yes</button>
	</mat-dialog-actions> -->
<!-- </div> -->


<h1 mat-dialog-title>Are You Sure ?</h1>
  <div mat-dialog-content>
    <!-- Are you sure you want to continue with this zipcode? -->
	Are you sure the zip code is correct?
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-dialog-close class="btnCustom btn-outline" [mat-dialog-close]="false">No</button>
    <button mat-button mat-dialog-close class="btnCustom btn-primary" [mat-dialog-close]="true">Yes</button>
  </div>
